!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.mediaContainer = null, this.mediaItems = [], this.currentMediaIndex = 0, 
      this.cyclingInterval = null, this.cyclingSpeed = 800, this.isHovering = !1, this.isTouchDevice = this.detectTouchDevice();
    }
    connectedCallback() {
      this.addEventListener("click", this.onClickHandler.bind(this)), this.init();
    }
    detectTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    init() {
      this.mediaContainer = this.querySelector("[data-media-container]"), this.mediaItems = this.querySelectorAll("[data-media-item]"), 
      this.mediaItems.length > 1 && this.setupMediaCycling();
    }
    setupMediaCycling() {
      this.isTouchDevice || (this.addEventListener("mouseenter", this.startMediaCycling.bind(this)), 
      this.addEventListener("mouseleave", this.stopMediaCycling.bind(this)));
    }
    startMediaCycling() {
      this.isHovering || this.mediaItems.length <= 1 || (this.isHovering = !0, this.currentMediaIndex = 0, 
      this.showNextMedia(), this.cyclingInterval = setInterval((() => {
        this.showNextMedia();
      }), this.cyclingSpeed));
    }
    stopMediaCycling() {
      this.isHovering = !1, this.cyclingInterval && (clearInterval(this.cyclingInterval), 
      this.cyclingInterval = null), this.resetToFirstMedia();
    }
    showNextMedia() {
      this.mediaItems[this.currentMediaIndex].classList.add("hidden"), this.currentMediaIndex = (this.currentMediaIndex + 1) % this.mediaItems.length, 
      this.mediaItems[this.currentMediaIndex].classList.remove("hidden");
    }
    resetToFirstMedia() {
      this.mediaItems.forEach((t => t.classList.add("hidden"))), this.currentMediaIndex = 0, 
      this.mediaItems[0].classList.remove("hidden");
    }
    onClickHandler(t) {
      if (t.target?.hasAttribute("data-ajax")) {
        t.preventDefault();
        const e = !!this.closest("[data-track-style-it-with-quick-add]"), i = t.target.getAttribute("href"), s = e ? JSON.stringify({
          properties: {
            _style_it_with: "true"
          }
        }) : void 0;
        fetch(i, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: s
        }).then((t => {
          if (!t.ok) throw new Error(`[${t.status}] ${t.statusText}`);
          this.dispatchEvent(new CustomEvent("product:added", {
            bubbles: !0
          }));
        })).catch((e => {
          console.error("Product add failed:", e), location.href = t.target.href;
        }));
      }
    }
    disconnectedCallback() {
      this.cyclingInterval && clearInterval(this.cyclingInterval);
    }
  }
  customElements.get("product-card") || customElements.define("product-card", t);
}();